import { Dispatch, SetStateAction, useMemo } from 'react'
import { NavigateFunction } from 'react-router-dom'
import ReactFlow from 'reactflow'
import { CarNode } from '../../../components/research/carNode/CarNode'
import { ModuleNode } from '../../../components/research/moduleNode/ModuleNode'
import { ModulesContent } from '../../../components/research/modulesContent/ModulesContent'
import { VehicleModulesResearchResponse } from '../../../models/response/VehicleModulesResearchResponse'
import { ModuleView } from '../../../models/VehicleModule'
import { buildModuleEdges } from '../utils/buildModuleEdges'
import { buildModuleNodes } from '../utils/buildModuleNodes'
import { VehiclePictureNode } from './VehiclePictureNode'

const NODE_TYPES = {
	car: CarNode,
	picture: VehiclePictureNode,
	module: ModuleNode,
	content: ModulesContent
}

export const ModulesTree = ({
	data,
	setTriggerUpdate,
	navigate,
	onModuleHover,
	onModuleLeave
}: {
	data: VehicleModulesResearchResponse | null,
	setTriggerUpdate: Dispatch<SetStateAction<number>>,
	navigate: NavigateFunction,
	onModuleHover: (event: React.MouseEvent, module: ModuleView) => void,
	onModuleLeave: () => void
}) => {

	const nodes = useMemo(
		() => buildModuleNodes(data, setTriggerUpdate, navigate, onModuleHover, onModuleLeave),
		[data, setTriggerUpdate, navigate, onModuleHover, onModuleLeave]
	)
	const edges = useMemo(() => buildModuleEdges(data, nodes), [data, nodes])
	return (
		<div style={{ width: "100%", height: "90%" }}>
			<ReactFlow
				nodes={nodes}
				edges={edges}
				nodeTypes={NODE_TYPES}
				minZoom={1}
				maxZoom={1}
				fitView
				proOptions={{ hideAttribution: true }}
				panOnDrag={false}
				panOnScroll={false}
				zoomOnScroll={false}
				zoomOnPinch={false}
				nodesDraggable={false}
				nodesConnectable={false}
			/>
		</div>
	)
}